module.exports = __webpack_public_path__ + "static/media/azure.da652f7a.jpg";